/**
 * Simple dialog state management hook
 * Extracted for reuse across admin pages
 */

import { useState, useCallback } from 'react';

export const useDialogState = (initialState = false) => {
  const [isOpen, setIsOpen] = useState(initialState);

  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);
  const toggle = useCallback(() => setIsOpen(prev => !prev), []);

  return { isOpen, setIsOpen, open, close, toggle };
};
